import React, { useState, useEffect, useRef } from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
// import "leaflet-defaulticon-compatibility";

function CmsMap({ component }) {
  return (
    <div className="relative" id={`${component.id ?? ""}`}>
      <iframe
        scrolling="no"
        title="WEBEABLE"
        aria-label="WEBEABLE"
        src="https://maps.google.com/maps?q=WEBEABLE&amp;t=m&amp;z=13&amp;output=embed&amp;iwloc=near"
      ></iframe>
    </div>
  );
}

export default CmsMap;
